/**
 * Keeps the print branding ("Powered by AmalERP · www.amalerp.com") in step
 * with the logged-in company, and adds it to screens that are printed
 * directly from the app (Ctrl+P / their own Print button): in the bottom page
 * margin of every printed page. Nothing shows on screen.
 *
 * Mounted once in App.js. Firebase cost: nothing.
 */
import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import {
  setPrintBrandCompany, isPrintBrandHidden, marginBoxesSupported, PRINT_BRAND_TEXT,
} from '../utils/printBranding';

const APP_CSS = '.amal-print-brand-app{display:none}'
  + '@page{@bottom-center{content:"Powered by AmalERP \\B7  www.amalerp.com";'
  + 'font-family:Arial,Helvetica,sans-serif;font-size:7pt;font-weight:normal;color:#8a8f98;vertical-align:top;padding-top:1.2mm}}';

// Browsers that cannot print in the page margin: once, under the content.
const APP_FALLBACK_CSS = '.amal-print-brand-app{display:none}'
  + '@media print{.amal-print-brand-app{display:block !important;margin-top:6mm;text-align:center;'
  + 'font-family:Arial,Helvetica,sans-serif;font-size:7pt;color:#8a8f98}}';

const PrintBrandHost = () => {
  const { activeCompany } = useAuth();
  useEffect(() => { setPrintBrandCompany(activeCompany); }, [activeCompany]);
  if (!activeCompany || isPrintBrandHidden(activeCompany)) return null;
  return (
    <>
      <style data-amal-print-brand="">{marginBoxesSupported() ? APP_CSS : APP_FALLBACK_CSS}</style>
      <div className="amal-print-brand-app" aria-hidden="true">{PRINT_BRAND_TEXT}</div>
    </>
  );
};

export default PrintBrandHost;
